import CardCarDetail from "../../components/cardCarDetail/index";
import "./index.css";
import visaIcon from "../../images/visa-icon.png";
import mastercardIcon from "../../images/mastercard_PNG.png";
import { useEffect } from "react";
import CityShuttleCard from "../../components/CityShuttleCard";

const Main = () => {
  useEffect(() => {
    localStorage.clear();
  });
  return (
    <div className="flex flex-col justify-center items-center md:space-y-[20px] space-y-[0px]">
      <div className="flex flex-col items-center justify-center ">
        <div>
          <CityShuttleCard isMainPage={true} scheduleId={0} />
        </div>

        <div className="flex flex-wrap items-center gap-x-10 justify-center md:my-0 my-[0px] ">
          <CardCarDetail carId={2} button={true} isMainPage={true} />
          <CardCarDetail carId={4} button={true} isMainPage={true} />
          <CardCarDetail carId={1} button={true} isMainPage={true} />
          <CardCarDetail carId={3} button={true} isMainPage={true} />
        </div>
      </div>

      <div className="flex z-0 max-w-[80px] justify-center">
        <img src={visaIcon} />
        <img src={mastercardIcon} />
      </div>
    </div>
  );
};

export default Main;
